import React, {Component} from "react";
import {LearnBox} from "./LearnBox";
import {getJsonObjectCachedOrFetch} from "../services/ServiceHelpers";
import {SubjectButton} from "./SubjectButton";
import {getTemplateStats} from "../services/TemplateStatsService";
import ProgressBar from "./ProgressBar";

export class ProblemTemplates extends Component {
    constructor(props) {
        super(props);
        this.state = {loading: true, subjectKey: props.subjectKey};
    }

    render() {
        if (this.state.loading) {
            return null;
        }

        return <LearnBox title="Træn opgavetype">
            <p>Træn opgaver af en bestemt type!</p>
            {this.state.problemTemplates.map(template => {
                    const stats = getTemplateStats(this.state.subjectKey, template.id);
                    const count = Math.max(10, stats.correctCount + stats.incorrectCount);
                    const completedPercentage = stats.correctCount * 100 / count;
                    return <div key={template.id}>
                        <SubjectButton key={template.id}
                                       url={"/practicetemplate/" + this.state.subjectKey + "/" + template.id}>
                            <span><strong>{template.theme.displayName}: </strong></span>
                            <span>{template.exampleProblem.text}</span>
                            <ProgressBar completed={completedPercentage}/>
                        </SubjectButton>
                    </div>;
                }
            )}
        </LearnBox>
    }

    componentDidMount() {
        getJsonObjectCachedOrFetch("api/problemtemplate", "problemTemplates").then(data => {
            const problemTemplates = data
                .filter(item => item.subject.key === this.state.subjectKey)
                .sort((a, b) => a.ratingStats.min - b.ratingStats.min);
            this.setState({problemTemplates: problemTemplates, loading: false})
        });
    }
}
